import enUS from 'date-fns/locale/en-US'

const SystemTimeZone = {
  locale: enUS,
  timeZone: 'America/New_York'
}

export default SystemTimeZone
